export default import.meta.ROLLDOWN_FILE_URL_z67H9cf8RyOzF4$_4LMSXw